import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "./Logo";
import { LanguagePill } from "./LanguagePill";
import { Button } from "@/components/ui/button";
import { RequestDemoDialog } from "./RequestDemoDialog";

export function PublicNav() {
  const { t } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [demoOpen, setDemoOpen] = useState(false);
  const links = [
    { kind: "route", to: "/", label: t("nav_home") },
    { kind: "section", id: "how", label: t("nav_how") },
    { kind: "section", id: "features", label: t("nav_features") },
    { kind: "route", to: "/trust", label: t("nav_security") },
  ];
  const goSection = (id) => {
    if (window.location.pathname !== "/") { navigate("/", { state: { scrollTo: id } }); }
    else { document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" }); }
  };
  const navClass = "text-sm font-medium text-slate-600 hover:text-brandblue transition-colors bg-transparent border-0 cursor-pointer";
  return (
    <header className="sticky top-0 z-40 w-full border-b border-slate-100 bg-white">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5">
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (l.kind === "route" ? (
            <Link key={l.label} to={l.to} data-testid={`nav-${l.label}`} className={navClass}>{l.label}</Link>
          ) : (
            <button key={l.label} type="button" onClick={() => goSection(l.id)} data-testid={`nav-${l.label}`} className={navClass}>{l.label}</button>
          )))}
        </nav>
        <div className="flex items-center gap-2.5">
          <Button data-testid="nav-request-demo-btn" onClick={() => setDemoOpen(true)}
            className="hidden sm:inline-flex rounded-full bg-brandteal text-white hover:bg-brandteal/90">{t("request_demo")}</Button>
          {user ? (
            <Button data-testid="nav-dashboard-btn" onClick={() => navigate("/dashboard")}
              className="rounded-full brand-gradient text-white hover:opacity-90">{t("dashboard")}</Button>
          ) : (
            <>
              <Button variant="outline" data-testid="nav-signin-btn" onClick={() => navigate("/login")}
                className="rounded-full border-slate-200">{t("sign_in")}</Button>
              <Button data-testid="nav-getstarted-btn" onClick={() => navigate("/register")}
                className="rounded-full brand-gradient text-white hover:opacity-90">{t("get_started")}</Button>
            </>
          )}
        </div>
      </div>
      <RequestDemoDialog open={demoOpen} onClose={() => setDemoOpen(false)} />
    </header>
  );
}
